import ProjectSitesMap from './ProjectSitesMap'

export default ProjectSitesMap
